/**
 * Created by ianva on 16/7/14.
 */

var _ = require('underscore');


/**
 * 处理商品列表的工具集合
 * 商品列表的数据结构见文档: http://i.shijiebang.net/wiki/pages/viewpage.action?pageId=11559307
 */
var productUtils = {

    /**
     * 按天排序
     * @param {Array} 商品列表
     * @return {Array} 按天排序后的商品列表
     */
    sortByDays ( productList ){

        return _.sortBy( productList, item=>{

            var days = item.use_day.split(',');
            var lastIndex = days.length - 1;
            
            return  Math.max(days[ lastIndex ])

        });
        
    }
    
};

module.exports = productUtils



/** WEBPACK FOOTER **
 ** ./script/util/productUtils.js
 **/